import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const revealSelector = [
  ".services-header-container",
  ".home-hero-copy",
  ".home-hero-visual",
  ".hero-metrics > div",
  ".services-container > div",
  ".why-us-overall-container",
  ".whyUs-container",
  ".company-des > *",
  ".facebook-feed-section > *",
  ".facebook-reel-card",
  ".services-header",
  ".service-list h3",
  ".services-page-des > *",
  ".portfolio-project-container",
  ".about-header > *",
  ".about-company-img",
  ".about-why-us > *",
  ".contact-container > *",
  ".contact-detail-container > *",
  ".factory-location > *",
  ".contact-main-layout > *",
  ".factory-map-section",
  ".service1-header > *",
  ".service-project-preview",
  "[class^='detail-section-'] > *",
].join(",");

function MotionController() {
  const { pathname } = useLocation();

  useEffect(() => {
    const items = Array.from(document.querySelectorAll(revealSelector));

    const prefersReducedMotion = typeof window.matchMedia === "function"
      && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion || typeof window.IntersectionObserver !== "function") {
      items.forEach((item) => item.classList.add("is-visible"));
      return undefined;
    }

    items.forEach((item, index) => {
      item.classList.add("reveal-item");
      item.style.setProperty("--reveal-delay", `${Math.min(index % 4, 3) * 70}ms`);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -48px" }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, [pathname]);

  return null;
}

export default MotionController;
